import { useMutation } from "@tanstack/react-query";
import { RESET_CURRENT_USER } from "../api/queries";
import { graphQLClient } from "../graphqlClient";

// Input params:
// confirmation: String - The confirmation phrase "reset me"
// options: ResetOptions - Optional selective reset options
export const useResetCurrentUser = () => {
  const resetUserMutation = async ({ confirmation, options }) => {
    return graphQLClient.request(RESET_CURRENT_USER, {
      confirmation,
      options,
    });
  };

  const mutation = useMutation({
    mutationFn: resetUserMutation,
    onSuccess: () => {
      localStorage.removeItem("REACT_QUERY_OFFLINE_CACHE");
    },
    onError: (error) => {
      console.error("Error resetting user:", error);
    },
  });

  return {
    resetUser: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    error: mutation.error,
  };
};
